<template>
  <div class="find-your-provider-grid">
    <div class="content-wrapper content-grid-item" id="hsf_find-your-provider">
      <div>
        <h2 class="find-your-provider_title">
          Need to finance another healthcare expense?
        </h2>
      </div>
      <div>
        <p class="find-your-provider_option_description">
          We have you covered. Find your provider to get started.
        </p>
      </div>
      <div>
        <PrimaryButton
          class="find-your-provider-btn"
          @clickHandler="findYouProviderClick"
          :text="'Find Your Provider'"
        >
        </PrimaryButton>
      </div>
    </div>
    <div class="image-wrapper image-grid-item">
      <div class="image-bubbles">
        <img
          class="find-your-provider_image_accent-circle"
          src="@Shared/assets/images/small-yellow-circle.svg"
          alt="Small yellow circle"
        />

        <img
          class="find-your-provider_image"
          src="@Shared/assets/images/BenefitsImage.png"
          alt="Doctor and child"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PrimaryButton from "@Shared/components/PrimaryButton.vue";
import router from "../../router";
export default {
  name: "FindYourProvider",
  components: {
    PrimaryButton,
  },

  methods: {
    findYouProviderClick() {
      router.push({ name: "search" });
    },
  },
};
</script>

<style lang="scss" scoped>
.find-your-provider-grid {
  display: grid;
  align-items: center;
  grid-template-columns: repeat(2, auto);
  margin: 10vh 25vh;
  column-gap: 25px;

  @media all and (max-width: $grid-breakpoint-lg) {
    display: grid;
    grid-template-columns: 1fr;
    row-gap: 10%;
    margin: 7% 0 15% 0;

    .content-grid-item {
      grid-row: 2;
    }

    .image-grid-item {
      grid-row: 1;
    }
  }

  .content-wrapper {
    position: relative;
    padding-left: 50px;
    padding-right: 50px;
    margin-left: 15px;
    margin-right: 15px;

    .btn-style {
      width: 200px;

      @media (max-width: $grid-breakpoint-sm) {
        width: 100%;
        padding: 10px;
        border-radius: 5px;
      }
    }

    @media (max-width: $grid-breakpoint-sm) {
      margin-top: 20px;
      padding-left: 15px;
      padding-right: 15px;
    }
  }

  .image-wrapper {
    display: flex;
    justify-content: center;

    @media all and (max-width: $grid-breakpoint-lg) {
      justify-content: center;
    }

    .image-bubbles {
      position: relative;
      max-height: 403px;
      max-width: 403px;

      .find-your-provider_image_accent-circle {
        position: absolute;
        top: 65%;
        z-index: 1;
        width: 132px;
        height: 132px;
        opacity: 0.5;

        @media all and (max-width: $grid-breakpoint-lg) {
          display: grid;
          grid-template-columns: 1fr;
          row-gap: 10%;
          margin: 0;
        }

        @media all and (max-width: $grid-breakpoint-md) {
          height: 102px;
          width: 102px;
        }
      }

      .find-your-provider_image {
        position: relative;
        width: 302px;
        height: 302px;

        @media all and (max-width: $grid-breakpoint-md) {
          height: 260px;
          width: 260px;
        }
      }
    }
  }

  .find-your-provider_title {
    font-size: 32px;
    font-weight: 500;
    line-height: 38px;
    padding-bottom: 15px;

    @media (max-width: $grid-breakpoint-sm) {
      font-size: 20px;
      line-height: 26px;
      font-weight: 500;
    }
  }

  .find-your-provider_option_description {
    font-size: 16px;
    line-height: 38px;
    padding-bottom: 15px;

    @media (max-width: $grid-breakpoint-sm) {
      font-size: 14px;
      line-height: 22px;
    }
  }

  .find-your-provider-btn {
    @media (max-width: $grid-breakpoint-sm) {
      margin-bottom: 120px;
    }
  }
}
</style>
